import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { MatIcon } from '@angular/material/icon'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        LandingPageSectionContainerModule,
        TranslationModule,
        MatIcon,
    ],
    selector: 'app-landing-page-planning',
    templateUrl: './landing-page-planning.component.html',
    styleUrls: ['./landing-page-planning.component.scss'],
})
export class LandingPagePlanningComponent {
    useCases = [
        {
            titleLine1: 'LandingPagePlanningETACalculationTitle1',
            titleLine2: 'LandingPagePlanningETACalculationTitle2',
            description: 'LandingPagePlanningETACalculationDescription',
            color: 'primary-extra-dark',
        },
        {
            titleLine1: 'LandingPagePlanningRevisionPlanningTitle1',
            titleLine2: 'LandingPagePlanningRevisionPlanningTitle2',
            description: 'LandingPagePlanningRevisionPlanningDescription',
            color: 'primary-dark',
        },
        {
            titleLine1: 'LandingPagePlanningMileageMonitoringTitle1',
            titleLine2: 'LandingPagePlanningMileageMonitoringTitle2',
            description: 'LandingPagePlanningMileageMonitoringDescription',
            color: 'primary',
        },
    ]
    constructor() {}
}
